// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"112":"621ca0eb","451":"0da72ec1","514":"48880d3b","700":"0e152718","802":"36199f2d"}[chunkId] + ".chunk.js";
};